import { z as b } from "zod";
var G = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ac(e) {
  if (e.__esModule) return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function a() {
      return this instanceof a ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var n = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(t, a, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), t;
}
const ve = b.enum([
  "payment-outlined",
  "ai-badge-outlined",
  "ai-badge-purple-gradient-outlined",
  "arrow-forward-outlined",
  "product-outlined",
  "sort-outlined",
  "bullhorn-outlined",
  "book-mark-outlined",
  "circle-check-filled",
  "star-box-outlined",
  "badge-radar-star-filled",
  "badge-radar-verified-filled",
  "crown-outlined",
  "crown-filled",
  "edit-outlined",
  "edit-2-outlined",
  "brand-blogger-filled",
  "brand-sina-filled",
  "brand-plurk-filled",
  "brand-instagram-filled",
  "brand-instagram-inactive-filled",
  "brand-facebook-filled",
  "brand-facebook-inactive-filled",
  "brand-facebook-circle-filled",
  "brand-youtube-filled",
  "brand-youtube-button-filled",
  "brand-youtube-inactive-filled",
  "brand-twitch-filled",
  "brand-thread-filled",
  "brand-tiktok-filled",
  "brand-google-filled",
  "brand-tiktok-inactive-filled",
  "brand-x-filled",
  "brand-x-inactive-filled",
  "radar-chart-outlined",
  "film-outlined",
  "key-outlined",
  "user-outlined",
  "home-outlined",
  "hand-shake-outlined",
  "user-square-outlined",
  "target-outlined",
  "bulb-on-outlined",
  "conversation-outlined",
  "rocket-outlined",
  "analytics-outlined",
  "face-open-mouth-outlined",
  "tags-filled",
  "no-data-outlined",
  "cooperation-post-outlined",
  "cooperation-video-outlined",
  "cooperation-live-outlined",
  "cooperation-event-outlined",
  "dollar-circle-outlined",
  "resume-outlined",
  "save-to-collection-outlined",
  "save-to-collection-filled",
  "table-outlined",
  "shopping-bag-outlined",
  "flag-outlined",
  "checks-outlined",
  "trending-plateau",
  "top-1-filled",
  "top-2-filled",
  "top-3-filled",
  "brand-facebook-corner-filled",
  "brand-instagram-corner-filled",
  "brand-youtube-corner-filled",
  "flag-jp-filled",
  "flag-th-filled",
  "flag-tw-filled",
  "flag-us-filled",
  "search-kol-filled",
  "social-performance-filled",
  "marketing-trend-filled",
  "report-performance-filled",
  "predict-competitor-filled",
  "predictive-report-filled"
]);
function yr() {
  this.__data__ = [], this.size = 0;
}
var br = yr;
function $r(e, r) {
  return e === r || e !== e && r !== r;
}
var Ve = $r, mr = Ve;
function Tr(e, r) {
  for (var t = e.length; t--; )
    if (mr(e[t][0], r))
      return t;
  return -1;
}
var k = Tr, Ar = k, Sr = Array.prototype, Or = Sr.splice;
function Cr(e) {
  var r = this.__data__, t = Ar(r, e);
  if (t < 0)
    return !1;
  var a = r.length - 1;
  return t == a ? r.pop() : Or.call(r, t, 1), --this.size, !0;
}
var Ir = Cr, wr = k;
function Pr(e) {
  var r = this.__data__, t = wr(r, e);
  return t < 0 ? void 0 : r[t][1];
}
var Er = Pr, Mr = k;
function Dr(e) {
  return Mr(this.__data__, e) > -1;
}
var xr = Dr, jr = k;
function Lr(e, r) {
  var t = this.__data__, a = jr(t, e);
  return a < 0 ? (++this.size, t.push([e, r])) : t[a][1] = r, this;
}
var Fr = Lr, Gr = br, Kr = Ir, Nr = Er, Rr = xr, Hr = Fr;
function C(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var a = e[r];
    this.set(a[0], a[1]);
  }
}
C.prototype.clear = Gr;
C.prototype.delete = Kr;
C.prototype.get = Nr;
C.prototype.has = Rr;
C.prototype.set = Hr;
var B = C, kr = B;
function Br() {
  this.__data__ = new kr(), this.size = 0;
}
var Ur = Br;
function zr(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
var qr = zr;
function Vr(e) {
  return this.__data__.get(e);
}
var Wr = Vr;
function Yr(e) {
  return this.__data__.has(e);
}
var Xr = Yr, Jr = typeof G == "object" && G && G.Object === Object && G, We = Jr, Zr = We, Qr = typeof self == "object" && self && self.Object === Object && self, et = Zr || Qr || Function("return this")(), $ = et, rt = $, tt = rt.Symbol, U = tt, pe = U, Ye = Object.prototype, at = Ye.hasOwnProperty, nt = Ye.toString, D = pe ? pe.toStringTag : void 0;
function it(e) {
  var r = at.call(e, D), t = e[D];
  try {
    e[D] = void 0;
    var a = !0;
  } catch {
  }
  var n = nt.call(e);
  return a && (r ? e[D] = t : delete e[D]), n;
}
var st = it, ot = Object.prototype, ut = ot.toString;
function lt(e) {
  return ut.call(e);
}
var ct = lt, ge = U, ft = st, dt = ct, vt = "[object Null]", pt = "[object Undefined]", _e = ge ? ge.toStringTag : void 0;
function gt(e) {
  return e == null ? e === void 0 ? pt : vt : _e && _e in Object(e) ? ft(e) : dt(e);
}
var x = gt;
function _t(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var z = _t, ht = x, yt = z, bt = "[object AsyncFunction]", $t = "[object Function]", mt = "[object GeneratorFunction]", Tt = "[object Proxy]";
function At(e) {
  if (!yt(e))
    return !1;
  var r = ht(e);
  return r == $t || r == mt || r == bt || r == Tt;
}
var Xe = At, St = $, Ot = St["__core-js_shared__"], Ct = Ot, X = Ct, he = function() {
  var e = /[^.]+$/.exec(X && X.keys && X.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function It(e) {
  return !!he && he in e;
}
var wt = It, Pt = Function.prototype, Et = Pt.toString;
function Mt(e) {
  if (e != null) {
    try {
      return Et.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Je = Mt, Dt = Xe, xt = wt, jt = z, Lt = Je, Ft = /[\\^$.*+?()[\]{}|]/g, Gt = /^\[object .+?Constructor\]$/, Kt = Function.prototype, Nt = Object.prototype, Rt = Kt.toString, Ht = Nt.hasOwnProperty, kt = RegExp(
  "^" + Rt.call(Ht).replace(Ft, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Bt(e) {
  if (!jt(e) || xt(e))
    return !1;
  var r = Dt(e) ? kt : Gt;
  return r.test(Lt(e));
}
var Ut = Bt;
function zt(e, r) {
  return e == null ? void 0 : e[r];
}
var qt = zt, Vt = Ut, Wt = qt;
function Yt(e, r) {
  var t = Wt(e, r);
  return Vt(t) ? t : void 0;
}
var I = Yt, Xt = I, Jt = $, Zt = Xt(Jt, "Map"), ne = Zt, Qt = I, ea = Qt(Object, "create"), q = ea, ye = q;
function ra() {
  this.__data__ = ye ? ye(null) : {}, this.size = 0;
}
var ta = ra;
function aa(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var na = aa, ia = q, sa = "__lodash_hash_undefined__", oa = Object.prototype, ua = oa.hasOwnProperty;
function la(e) {
  var r = this.__data__;
  if (ia) {
    var t = r[e];
    return t === sa ? void 0 : t;
  }
  return ua.call(r, e) ? r[e] : void 0;
}
var ca = la, fa = q, da = Object.prototype, va = da.hasOwnProperty;
function pa(e) {
  var r = this.__data__;
  return fa ? r[e] !== void 0 : va.call(r, e);
}
var ga = pa, _a = q, ha = "__lodash_hash_undefined__";
function ya(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = _a && r === void 0 ? ha : r, this;
}
var ba = ya, $a = ta, ma = na, Ta = ca, Aa = ga, Sa = ba;
function w(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var a = e[r];
    this.set(a[0], a[1]);
  }
}
w.prototype.clear = $a;
w.prototype.delete = ma;
w.prototype.get = Ta;
w.prototype.has = Aa;
w.prototype.set = Sa;
var Oa = w, be = Oa, Ca = B, Ia = ne;
function wa() {
  this.size = 0, this.__data__ = {
    hash: new be(),
    map: new (Ia || Ca)(),
    string: new be()
  };
}
var Pa = wa;
function Ea(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
var Ma = Ea, Da = Ma;
function xa(e, r) {
  var t = e.__data__;
  return Da(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
var V = xa, ja = V;
function La(e) {
  var r = ja(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
var Fa = La, Ga = V;
function Ka(e) {
  return Ga(this, e).get(e);
}
var Na = Ka, Ra = V;
function Ha(e) {
  return Ra(this, e).has(e);
}
var ka = Ha, Ba = V;
function Ua(e, r) {
  var t = Ba(this, e), a = t.size;
  return t.set(e, r), this.size += t.size == a ? 0 : 1, this;
}
var za = Ua, qa = Pa, Va = Fa, Wa = Na, Ya = ka, Xa = za;
function P(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var a = e[r];
    this.set(a[0], a[1]);
  }
}
P.prototype.clear = qa;
P.prototype.delete = Va;
P.prototype.get = Wa;
P.prototype.has = Ya;
P.prototype.set = Xa;
var ie = P, Ja = B, Za = ne, Qa = ie, en = 200;
function rn(e, r) {
  var t = this.__data__;
  if (t instanceof Ja) {
    var a = t.__data__;
    if (!Za || a.length < en - 1)
      return a.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new Qa(a);
  }
  return t.set(e, r), this.size = t.size, this;
}
var tn = rn, an = B, nn = Ur, sn = qr, on = Wr, un = Xr, ln = tn;
function E(e) {
  var r = this.__data__ = new an(e);
  this.size = r.size;
}
E.prototype.clear = nn;
E.prototype.delete = sn;
E.prototype.get = on;
E.prototype.has = un;
E.prototype.set = ln;
var Ze = E, cn = "__lodash_hash_undefined__";
function fn(e) {
  return this.__data__.set(e, cn), this;
}
var dn = fn;
function vn(e) {
  return this.__data__.has(e);
}
var pn = vn, gn = ie, _n = dn, hn = pn;
function N(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new gn(); ++r < t; )
    this.add(e[r]);
}
N.prototype.add = N.prototype.push = _n;
N.prototype.has = hn;
var yn = N;
function bn(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length; ++t < a; )
    if (r(e[t], t, e))
      return !0;
  return !1;
}
var $n = bn;
function mn(e, r) {
  return e.has(r);
}
var Tn = mn, An = yn, Sn = $n, On = Tn, Cn = 1, In = 2;
function wn(e, r, t, a, n, i) {
  var s = t & Cn, o = e.length, l = r.length;
  if (o != l && !(s && l > o))
    return !1;
  var u = i.get(e), v = i.get(r);
  if (u && v)
    return u == r && v == e;
  var d = -1, f = !0, h = t & In ? new An() : void 0;
  for (i.set(e, r), i.set(r, e); ++d < o; ) {
    var p = e[d], g = r[d];
    if (a)
      var m = s ? a(g, p, d, r, e, i) : a(p, g, d, e, r, i);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!Sn(r, function(A, S) {
        if (!On(h, S) && (p === A || n(p, A, t, a, i)))
          return h.push(S);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === g || n(p, g, t, a, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(r), f;
}
var Qe = wn, Pn = $, En = Pn.Uint8Array, Mn = En;
function Dn(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(a, n) {
    t[++r] = [n, a];
  }), t;
}
var xn = Dn;
function jn(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(a) {
    t[++r] = a;
  }), t;
}
var Ln = jn, $e = U, me = Mn, Fn = Ve, Gn = Qe, Kn = xn, Nn = Ln, Rn = 1, Hn = 2, kn = "[object Boolean]", Bn = "[object Date]", Un = "[object Error]", zn = "[object Map]", qn = "[object Number]", Vn = "[object RegExp]", Wn = "[object Set]", Yn = "[object String]", Xn = "[object Symbol]", Jn = "[object ArrayBuffer]", Zn = "[object DataView]", Te = $e ? $e.prototype : void 0, J = Te ? Te.valueOf : void 0;
function Qn(e, r, t, a, n, i, s) {
  switch (t) {
    case Zn:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case Jn:
      return !(e.byteLength != r.byteLength || !i(new me(e), new me(r)));
    case kn:
    case Bn:
    case qn:
      return Fn(+e, +r);
    case Un:
      return e.name == r.name && e.message == r.message;
    case Vn:
    case Yn:
      return e == r + "";
    case zn:
      var o = Kn;
    case Wn:
      var l = a & Rn;
      if (o || (o = Nn), e.size != r.size && !l)
        return !1;
      var u = s.get(e);
      if (u)
        return u == r;
      a |= Hn, s.set(e, r);
      var v = Gn(o(e), o(r), a, n, i, s);
      return s.delete(e), v;
    case Xn:
      if (J)
        return J.call(e) == J.call(r);
  }
  return !1;
}
var ei = Qn;
function ri(e, r) {
  for (var t = -1, a = r.length, n = e.length; ++t < a; )
    e[n + t] = r[t];
  return e;
}
var ti = ri, ai = Array.isArray, T = ai, ni = ti, ii = T;
function si(e, r, t) {
  var a = r(e);
  return ii(e) ? a : ni(a, t(e));
}
var oi = si;
function ui(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length, n = 0, i = []; ++t < a; ) {
    var s = e[t];
    r(s, t, e) && (i[n++] = s);
  }
  return i;
}
var li = ui;
function ci() {
  return [];
}
var fi = ci, di = li, vi = fi, pi = Object.prototype, gi = pi.propertyIsEnumerable, Ae = Object.getOwnPropertySymbols, _i = Ae ? function(e) {
  return e == null ? [] : (e = Object(e), di(Ae(e), function(r) {
    return gi.call(e, r);
  }));
} : vi, hi = _i;
function yi(e, r) {
  for (var t = -1, a = Array(e); ++t < e; )
    a[t] = r(t);
  return a;
}
var bi = yi;
function $i(e) {
  return e != null && typeof e == "object";
}
var j = $i, mi = x, Ti = j, Ai = "[object Arguments]";
function Si(e) {
  return Ti(e) && mi(e) == Ai;
}
var Oi = Si, Se = Oi, Ci = j, er = Object.prototype, Ii = er.hasOwnProperty, wi = er.propertyIsEnumerable, Pi = Se(/* @__PURE__ */ function() {
  return arguments;
}()) ? Se : function(e) {
  return Ci(e) && Ii.call(e, "callee") && !wi.call(e, "callee");
}, rr = Pi, R = { exports: {} };
function Ei() {
  return !1;
}
var Mi = Ei;
R.exports;
(function(e, r) {
  var t = $, a = Mi, n = r && !r.nodeType && r, i = n && !0 && e && !e.nodeType && e, s = i && i.exports === n, o = s ? t.Buffer : void 0, l = o ? o.isBuffer : void 0, u = l || a;
  e.exports = u;
})(R, R.exports);
var tr = R.exports, Di = 9007199254740991, xi = /^(?:0|[1-9]\d*)$/;
function ji(e, r) {
  var t = typeof e;
  return r = r ?? Di, !!r && (t == "number" || t != "symbol" && xi.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var ar = ji, Li = 9007199254740991;
function Fi(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Li;
}
var se = Fi, Gi = x, Ki = se, Ni = j, Ri = "[object Arguments]", Hi = "[object Array]", ki = "[object Boolean]", Bi = "[object Date]", Ui = "[object Error]", zi = "[object Function]", qi = "[object Map]", Vi = "[object Number]", Wi = "[object Object]", Yi = "[object RegExp]", Xi = "[object Set]", Ji = "[object String]", Zi = "[object WeakMap]", Qi = "[object ArrayBuffer]", es = "[object DataView]", rs = "[object Float32Array]", ts = "[object Float64Array]", as = "[object Int8Array]", ns = "[object Int16Array]", is = "[object Int32Array]", ss = "[object Uint8Array]", os = "[object Uint8ClampedArray]", us = "[object Uint16Array]", ls = "[object Uint32Array]", c = {};
c[rs] = c[ts] = c[as] = c[ns] = c[is] = c[ss] = c[os] = c[us] = c[ls] = !0;
c[Ri] = c[Hi] = c[Qi] = c[ki] = c[es] = c[Bi] = c[Ui] = c[zi] = c[qi] = c[Vi] = c[Wi] = c[Yi] = c[Xi] = c[Ji] = c[Zi] = !1;
function cs(e) {
  return Ni(e) && Ki(e.length) && !!c[Gi(e)];
}
var fs = cs;
function ds(e) {
  return function(r) {
    return e(r);
  };
}
var vs = ds, H = { exports: {} };
H.exports;
(function(e, r) {
  var t = We, a = r && !r.nodeType && r, n = a && !0 && e && !e.nodeType && e, i = n && n.exports === a, s = i && t.process, o = function() {
    try {
      var l = n && n.require && n.require("util").types;
      return l || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(H, H.exports);
var ps = H.exports, gs = fs, _s = vs, Oe = ps, Ce = Oe && Oe.isTypedArray, hs = Ce ? _s(Ce) : gs, nr = hs, ys = bi, bs = rr, $s = T, ms = tr, Ts = ar, As = nr, Ss = Object.prototype, Os = Ss.hasOwnProperty;
function Cs(e, r) {
  var t = $s(e), a = !t && bs(e), n = !t && !a && ms(e), i = !t && !a && !n && As(e), s = t || a || n || i, o = s ? ys(e.length, String) : [], l = o.length;
  for (var u in e)
    (r || Os.call(e, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Ts(u, l))) && o.push(u);
  return o;
}
var Is = Cs, ws = Object.prototype;
function Ps(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || ws;
  return e === t;
}
var Es = Ps;
function Ms(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var Ds = Ms, xs = Ds, js = xs(Object.keys, Object), Ls = js, Fs = Es, Gs = Ls, Ks = Object.prototype, Ns = Ks.hasOwnProperty;
function Rs(e) {
  if (!Fs(e))
    return Gs(e);
  var r = [];
  for (var t in Object(e))
    Ns.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
var Hs = Rs, ks = Xe, Bs = se;
function Us(e) {
  return e != null && Bs(e.length) && !ks(e);
}
var ir = Us, zs = Is, qs = Hs, Vs = ir;
function Ws(e) {
  return Vs(e) ? zs(e) : qs(e);
}
var oe = Ws, Ys = oi, Xs = hi, Js = oe;
function Zs(e) {
  return Ys(e, Js, Xs);
}
var Qs = Zs, Ie = Qs, eo = 1, ro = Object.prototype, to = ro.hasOwnProperty;
function ao(e, r, t, a, n, i) {
  var s = t & eo, o = Ie(e), l = o.length, u = Ie(r), v = u.length;
  if (l != v && !s)
    return !1;
  for (var d = l; d--; ) {
    var f = o[d];
    if (!(s ? f in r : to.call(r, f)))
      return !1;
  }
  var h = i.get(e), p = i.get(r);
  if (h && p)
    return h == r && p == e;
  var g = !0;
  i.set(e, r), i.set(r, e);
  for (var m = s; ++d < l; ) {
    f = o[d];
    var A = e[f], S = r[f];
    if (a)
      var de = s ? a(S, A, f, r, e, i) : a(A, S, f, e, r, i);
    if (!(de === void 0 ? A === S || n(A, S, t, a, i) : de)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var L = e.constructor, F = r.constructor;
    L != F && "constructor" in e && "constructor" in r && !(typeof L == "function" && L instanceof L && typeof F == "function" && F instanceof F) && (g = !1);
  }
  return i.delete(e), i.delete(r), g;
}
var no = ao, io = I, so = $, oo = io(so, "DataView"), uo = oo, lo = I, co = $, fo = lo(co, "Promise"), vo = fo, po = I, go = $, _o = po(go, "Set"), ho = _o, yo = I, bo = $, $o = yo(bo, "WeakMap"), mo = $o, Q = uo, ee = ne, re = vo, te = ho, ae = mo, sr = x, M = Je, we = "[object Map]", To = "[object Object]", Pe = "[object Promise]", Ee = "[object Set]", Me = "[object WeakMap]", De = "[object DataView]", Ao = M(Q), So = M(ee), Oo = M(re), Co = M(te), Io = M(ae), O = sr;
(Q && O(new Q(new ArrayBuffer(1))) != De || ee && O(new ee()) != we || re && O(re.resolve()) != Pe || te && O(new te()) != Ee || ae && O(new ae()) != Me) && (O = function(e) {
  var r = sr(e), t = r == To ? e.constructor : void 0, a = t ? M(t) : "";
  if (a)
    switch (a) {
      case Ao:
        return De;
      case So:
        return we;
      case Oo:
        return Pe;
      case Co:
        return Ee;
      case Io:
        return Me;
    }
  return r;
});
var wo = O, Z = Ze, Po = Qe, Eo = ei, Mo = no, xe = wo, je = T, Le = tr, Do = nr, xo = 1, Fe = "[object Arguments]", Ge = "[object Array]", K = "[object Object]", jo = Object.prototype, Ke = jo.hasOwnProperty;
function Lo(e, r, t, a, n, i) {
  var s = je(e), o = je(r), l = s ? Ge : xe(e), u = o ? Ge : xe(r);
  l = l == Fe ? K : l, u = u == Fe ? K : u;
  var v = l == K, d = u == K, f = l == u;
  if (f && Le(e)) {
    if (!Le(r))
      return !1;
    s = !0, v = !1;
  }
  if (f && !v)
    return i || (i = new Z()), s || Do(e) ? Po(e, r, t, a, n, i) : Eo(e, r, l, t, a, n, i);
  if (!(t & xo)) {
    var h = v && Ke.call(e, "__wrapped__"), p = d && Ke.call(r, "__wrapped__");
    if (h || p) {
      var g = h ? e.value() : e, m = p ? r.value() : r;
      return i || (i = new Z()), n(g, m, t, a, i);
    }
  }
  return f ? (i || (i = new Z()), Mo(e, r, t, a, n, i)) : !1;
}
var Fo = Lo, Go = Fo, Ne = j;
function or(e, r, t, a, n) {
  return e === r ? !0 : e == null || r == null || !Ne(e) && !Ne(r) ? e !== e && r !== r : Go(e, r, t, a, or, n);
}
var ur = or, Ko = Ze, No = ur, Ro = 1, Ho = 2;
function ko(e, r, t, a) {
  var n = t.length, i = n, s = !a;
  if (e == null)
    return !i;
  for (e = Object(e); n--; ) {
    var o = t[n];
    if (s && o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++n < i; ) {
    o = t[n];
    var l = o[0], u = e[l], v = o[1];
    if (s && o[2]) {
      if (u === void 0 && !(l in e))
        return !1;
    } else {
      var d = new Ko();
      if (a)
        var f = a(u, v, l, e, r, d);
      if (!(f === void 0 ? No(v, u, Ro | Ho, a, d) : f))
        return !1;
    }
  }
  return !0;
}
var Bo = ko, Uo = z;
function zo(e) {
  return e === e && !Uo(e);
}
var lr = zo, qo = lr, Vo = oe;
function Wo(e) {
  for (var r = Vo(e), t = r.length; t--; ) {
    var a = r[t], n = e[a];
    r[t] = [a, n, qo(n)];
  }
  return r;
}
var Yo = Wo;
function Xo(e, r) {
  return function(t) {
    return t == null ? !1 : t[e] === r && (r !== void 0 || e in Object(t));
  };
}
var cr = Xo, Jo = Bo, Zo = Yo, Qo = cr;
function eu(e) {
  var r = Zo(e);
  return r.length == 1 && r[0][2] ? Qo(r[0][0], r[0][1]) : function(t) {
    return t === e || Jo(t, e, r);
  };
}
var ru = eu, tu = x, au = j, nu = "[object Symbol]";
function iu(e) {
  return typeof e == "symbol" || au(e) && tu(e) == nu;
}
var W = iu, su = T, ou = W, uu = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lu = /^\w*$/;
function cu(e, r) {
  if (su(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || ou(e) ? !0 : lu.test(e) || !uu.test(e) || r != null && e in Object(r);
}
var ue = cu, fr = ie, fu = "Expected a function";
function le(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(fu);
  var t = function() {
    var a = arguments, n = r ? r.apply(this, a) : a[0], i = t.cache;
    if (i.has(n))
      return i.get(n);
    var s = e.apply(this, a);
    return t.cache = i.set(n, s) || i, s;
  };
  return t.cache = new (le.Cache || fr)(), t;
}
le.Cache = fr;
var dr = le;
const Sc = /* @__PURE__ */ qe(dr);
var du = dr, vu = 500;
function pu(e) {
  var r = du(e, function(a) {
    return t.size === vu && t.clear(), a;
  }), t = r.cache;
  return r;
}
var gu = pu, _u = gu, hu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, yu = /\\(\\)?/g, bu = _u(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(hu, function(t, a, n, i) {
    r.push(n ? i.replace(yu, "$1") : a || t);
  }), r;
}), $u = bu;
function mu(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length, n = Array(a); ++t < a; )
    n[t] = r(e[t], t, e);
  return n;
}
var Tu = mu, Re = U, Au = Tu, Su = T, Ou = W, Cu = 1 / 0, He = Re ? Re.prototype : void 0, ke = He ? He.toString : void 0;
function vr(e) {
  if (typeof e == "string")
    return e;
  if (Su(e))
    return Au(e, vr) + "";
  if (Ou(e))
    return ke ? ke.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -Cu ? "-0" : r;
}
var Iu = vr, wu = Iu;
function Pu(e) {
  return e == null ? "" : wu(e);
}
var Eu = Pu, Mu = T, Du = ue, xu = $u, ju = Eu;
function Lu(e, r) {
  return Mu(e) ? e : Du(e, r) ? [e] : xu(ju(e));
}
var pr = Lu, Fu = W, Gu = 1 / 0;
function Ku(e) {
  if (typeof e == "string" || Fu(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -Gu ? "-0" : r;
}
var Y = Ku, Nu = pr, Ru = Y;
function Hu(e, r) {
  r = Nu(r, e);
  for (var t = 0, a = r.length; e != null && t < a; )
    e = e[Ru(r[t++])];
  return t && t == a ? e : void 0;
}
var gr = Hu, ku = gr;
function Bu(e, r, t) {
  var a = e == null ? void 0 : ku(e, r);
  return a === void 0 ? t : a;
}
var Uu = Bu;
function zu(e, r) {
  return e != null && r in Object(e);
}
var qu = zu, Vu = pr, Wu = rr, Yu = T, Xu = ar, Ju = se, Zu = Y;
function Qu(e, r, t) {
  r = Vu(r, e);
  for (var a = -1, n = r.length, i = !1; ++a < n; ) {
    var s = Zu(r[a]);
    if (!(i = e != null && t(e, s)))
      break;
    e = e[s];
  }
  return i || ++a != n ? i : (n = e == null ? 0 : e.length, !!n && Ju(n) && Xu(s, n) && (Yu(e) || Wu(e)));
}
var el = Qu, rl = qu, tl = el;
function al(e, r) {
  return e != null && tl(e, r, rl);
}
var nl = al, il = ur, sl = Uu, ol = nl, ul = ue, ll = lr, cl = cr, fl = Y, dl = 1, vl = 2;
function pl(e, r) {
  return ul(e) && ll(r) ? cl(fl(e), r) : function(t) {
    var a = sl(t, e);
    return a === void 0 && a === r ? ol(t, e) : il(r, a, dl | vl);
  };
}
var gl = pl;
function _l(e) {
  return e;
}
var hl = _l;
function yl(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
var bl = yl, $l = gr;
function ml(e) {
  return function(r) {
    return $l(r, e);
  };
}
var Tl = ml, Al = bl, Sl = Tl, Ol = ue, Cl = Y;
function Il(e) {
  return Ol(e) ? Al(Cl(e)) : Sl(e);
}
var wl = Il, Pl = ru, El = gl, Ml = hl, Dl = T, xl = wl;
function jl(e) {
  return typeof e == "function" ? e : e == null ? Ml : typeof e == "object" ? Dl(e) ? El(e[0], e[1]) : Pl(e) : xl(e);
}
var _r = jl, Ll = _r, Fl = ir, Gl = oe;
function Kl(e) {
  return function(r, t, a) {
    var n = Object(r);
    if (!Fl(r)) {
      var i = Ll(t);
      r = Gl(r), t = function(o) {
        return i(n[o], o, n);
      };
    }
    var s = e(r, t, a);
    return s > -1 ? n[i ? r[s] : s] : void 0;
  };
}
var Nl = Kl;
function Rl(e, r, t, a) {
  for (var n = e.length, i = t + (a ? 1 : -1); a ? i-- : ++i < n; )
    if (r(e[i], i, e))
      return i;
  return -1;
}
var Hl = Rl, kl = /\s/;
function Bl(e) {
  for (var r = e.length; r-- && kl.test(e.charAt(r)); )
    ;
  return r;
}
var Ul = Bl, zl = Ul, ql = /^\s+/;
function Vl(e) {
  return e && e.slice(0, zl(e) + 1).replace(ql, "");
}
var Wl = Vl, Yl = Wl, Be = z, Xl = W, Ue = NaN, Jl = /^[-+]0x[0-9a-f]+$/i, Zl = /^0b[01]+$/i, Ql = /^0o[0-7]+$/i, ec = parseInt;
function rc(e) {
  if (typeof e == "number")
    return e;
  if (Xl(e))
    return Ue;
  if (Be(e)) {
    var r = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Be(r) ? r + "" : r;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Yl(e);
  var t = Zl.test(e);
  return t || Ql.test(e) ? ec(e.slice(2), t ? 2 : 8) : Jl.test(e) ? Ue : +e;
}
var tc = rc, ac = tc, ze = 1 / 0, nc = 17976931348623157e292;
function ic(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = ac(e), e === ze || e === -ze) {
    var r = e < 0 ? -1 : 1;
    return r * nc;
  }
  return e === e ? e : 0;
}
var sc = ic, oc = sc;
function uc(e) {
  var r = oc(e), t = r % 1;
  return r === r ? t ? r - t : r : 0;
}
var lc = uc, cc = Hl, fc = _r, dc = lc, vc = Math.max;
function pc(e, r, t) {
  var a = e == null ? 0 : e.length;
  if (!a)
    return -1;
  var n = t == null ? 0 : dc(t);
  return n < 0 && (n = vc(a + n, 0)), cc(e, fc(r), n);
}
var gc = pc, _c = Nl, hc = gc, yc = _c(hc), bc = yc;
const ce = /* @__PURE__ */ qe(bc), _ = b.enum([
  "all",
  "blog",
  "fb",
  "fb_person",
  "ig",
  "other",
  "tiktok",
  "yt",
  "twitter"
]), y = b.enum([
  "all",
  "blog",
  "facebook",
  "instagram",
  "other",
  "tiktok",
  "youtube",
  "twitter"
]);
var hr = /* @__PURE__ */ ((e) => (e[e.All = -1] = "All", e[e.YouTube = 0] = "YouTube", e[e.Facebook = 1] = "Facebook", e[e.Instagram = 3] = "Instagram", e[e.TikTok = 4] = "TikTok", e[e.Twitter = 5] = "Twitter", e[e.Other = 999] = "Other", e))(hr || {});
const $c = b.nativeEnum(hr);
b.object({
  code: y,
  shortcode: _,
  title: b.string(),
  type: b.optional($c),
  icon: b.optional(ve),
  inactiveIcon: b.optional(ve)
});
const fe = [
  {
    code: y.enum.all,
    shortcode: _.enum.all,
    title: "All"
  },
  {
    type: 999,
    code: y.enum.other,
    shortcode: _.enum.other,
    title: "Other"
  },
  {
    code: y.enum.blog,
    shortcode: _.enum.blog,
    title: "Blog"
  },
  {
    code: y.enum.tiktok,
    shortcode: _.enum.tiktok,
    title: "TikTok",
    type: 4
    /* TikTok */
  },
  {
    code: y.enum.facebook,
    shortcode: _.enum.fb,
    title: "Facebook",
    type: 1,
    icon: "brand-facebook-filled",
    inactiveIcon: "brand-facebook-inactive-filled"
  },
  {
    code: y.enum.instagram,
    shortcode: _.enum.ig,
    title: "Instagram",
    type: 3,
    icon: "brand-instagram-filled",
    inactiveIcon: "brand-instagram-inactive-filled"
  },
  {
    code: y.enum.youtube,
    shortcode: _.enum.yt,
    title: "YouTube",
    type: 0,
    icon: "brand-youtube-filled",
    inactiveIcon: "brand-youtube-inactive-filled"
  },
  {
    code: y.enum.twitter,
    shortcode: _.enum.twitter,
    title: "Twitter",
    type: 5
    /* Twitter */
  }
], Oc = (e) => ce(fe, { code: e }), Cc = (e = "") => {
  const r = _.safeParse(e);
  return r.success ? ce(fe, { shortcode: r.data }) : void 0;
}, Ic = (e) => ce(fe, { type: e }), wc = {
  beauty: {
    id: "beauty",
    netSuiteValue: "BT 美容業",
    i18nKey: "general:ad_industry_bt",
    isDeprecated: !1
  },
  medicalHealthcare: {
    id: "medicalHealthcare",
    netSuiteValue: "MH 醫療生技及保健業",
    i18nKey: "general:ad_industry_mh",
    isDeprecated: !1
  },
  foodBeverage: {
    id: "foodBeverage",
    netSuiteValue: "FB 食品飲料業",
    i18nKey: "general:ad_industry_fb",
    isDeprecated: !1
  },
  retailWholesale: {
    id: "retailWholesale",
    netSuiteValue: "RW 批發及零售業",
    i18nKey: "general:ad_industry_rw",
    isDeprecated: !1
  },
  eCommerce: {
    id: "eCommerce",
    netSuiteValue: "EC 電子商務業",
    i18nKey: "general:ad_industry_ec",
    isDeprecated: !1
  },
  financial: {
    id: "financial",
    netSuiteValue: "FN 金融業",
    i18nKey: "general:ad_industry_fn",
    isDeprecated: !1
  },
  computersElectronics: {
    id: "computersElectronics",
    netSuiteValue: "CE 資訊電子工業",
    i18nKey: "general:ad_industry_ce",
    isDeprecated: !1
  },
  travelLeisure: {
    id: "travelLeisure",
    netSuiteValue: "TL 觀光餐旅業",
    i18nKey: "general:ad_industry_tl",
    isDeprecated: !1
  },
  gaming: {
    id: "gaming",
    netSuiteValue: "GM 遊戲業",
    i18nKey: "general:ad_industry_gm",
    isDeprecated: !1
  },
  telecommunications: {
    id: "telecommunications",
    netSuiteValue: "TC 通訊業",
    i18nKey: "general:ad_industry_tc",
    isDeprecated: !1
  },
  entertainment: {
    id: "entertainment",
    netSuiteValue: "EN 娛樂媒體業",
    i18nKey: "general:ad_industry_en",
    isDeprecated: !1
  },
  education: {
    id: "education",
    netSuiteValue: "ED 教育業",
    i18nKey: "general:ad_industry_ed",
    isDeprecated: !1
  },
  govNonProfit: {
    id: "govNonProfit",
    netSuiteValue: "GN 政府及社服業",
    i18nKey: "general:ad_industry_gn",
    isDeprecated: !1
  },
  advertisingMarketing: {
    id: "advertisingMarketing",
    netSuiteValue: "AM 廣告行銷業",
    i18nKey: "general:ad_industry_am",
    isDeprecated: !1
  },
  realEstate: {
    id: "realEstate",
    netSuiteValue: "RE 營造及不動產業",
    i18nKey: "general:ad_industry_re",
    isDeprecated: !1
  },
  others: {
    id: "others",
    netSuiteValue: "OT 其他",
    i18nKey: "general:ad_industry_ot",
    isDeprecated: !1
  },
  // 這些只有舊的使用者才會有，新註冊的人不能讓它選
  softwareInternet: {
    id: "softwareInternet",
    netSuiteValue: "SI 資訊軟體業",
    i18nKey: "general:ad_industry_si",
    isDeprecated: !0
  },
  otherManufacturing: {
    id: "otherManufacturing",
    netSuiteValue: "OM 其他製造業",
    i18nKey: "general:ad_industry_om",
    isDeprecated: !0
  }
}, mc = {
  beautyCare: "beauty",
  healthFood: "medicalHealthcare",
  food: "foodBeverage",
  retail: "retailWholesale",
  "e-commerce": "eCommerce",
  babyCare: "retailWholesale",
  finance: "financial",
  technology: "computersElectronics",
  tourism: "travelLeisure",
  gaming: "gaming",
  sport: "travelLeisure",
  telecom: "telecommunications",
  media: "entertainment",
  education: "education",
  npo: "govNonProfit",
  marketing: "advertisingMarketing",
  realEstate: "realEstate",
  freelancer: "others",
  others: "others"
}, Pc = (e) => {
  if (e !== void 0)
    return mc[e] ?? e;
};
export {
  j as A,
  ps as B,
  vs as C,
  Ze as D,
  tr as E,
  Qs as F,
  T as G,
  W as H,
  _r as I,
  Oc as J,
  y as K,
  $c as L,
  hr as P,
  I as _,
  wc as a,
  G as b,
  Ic as c,
  qe as d,
  ve as e,
  Cc as f,
  Pc as g,
  Ac as h,
  Ve as i,
  z as j,
  oe as k,
  Es as l,
  Sc as m,
  Is as n,
  mc as o,
  _ as p,
  ir as q,
  $ as r,
  hi as s,
  Ds as t,
  ti as u,
  fi as v,
  oi as w,
  Mn as x,
  U as y,
  wo as z
};
